export const ADMIN_NOTIFICATION_MODES = {
  ALL: 'ALL',
  DIRECT_ONLY: 'DIRECT_ONLY'
}

export const getAdminNotificationMode = (data) =>
  data?.notificationPreferences?.adminMode ===
  ADMIN_NOTIFICATION_MODES.DIRECT_ONLY
    ? ADMIN_NOTIFICATION_MODES.DIRECT_ONLY
    : ADMIN_NOTIFICATION_MODES.ALL

export const isDirectOnlyAdministrator = (user, adminMode) =>
  user?.role === 'ADMINISTRADOR' &&
  adminMode === ADMIN_NOTIFICATION_MODES.DIRECT_ONLY
